/**
 * @owner @Appboy/messaging-experience
 */
import { cohortRemoteLookupValidators } from "../.generated/cohortRemoteLookup";
import type { CohortRemoteLookupProvider } from "../.generated/cohortRemoteLookup";

export const cohortProvider: CohortRemoteLookupProvider = {
  mapItemToId: (item) => `${item.partner_token}:${item.cohort_id}`,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: cohortRemoteLookupValidators,
};
